// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.info[data-v-05f2cc56] {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.info-form[data-v-05f2cc56] {\n  font-weight: 400;\n  font-size: 14px;\n  color: #303033;\n}\n", ""]);
// Exports
module.exports = exports;
